import axios from 'axios';
import React, { useState } from 'react';
import styles from './KeysComponent.module.css';

const KeysComponent = ({ setToken }) => {
  const [uKey, setUKey] = useState('');
  const [gKey, setGKey] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        'https://your-backend.com/admin/update-keys',
        { uKey, gKey },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` },
        }
      );
      setUKey('');
      setGKey('');
      setSuccess('API keys updated successfully!');
      setError('');
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem('adminToken');
        setToken('');
        setError('Session expired. Please log in again.');
      } else {
        setError('Failed to update keys. Please try again.');
      }
      setSuccess('');
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Update API Keys</h2>
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.grid}>
          <div className={styles.formGroup}>
            <label className={styles.label}>Ultravox Key (uKey)</label>
            <input
              type="text"
              value={uKey}
              onChange={(e) => setUKey(e.target.value)}
              className={styles.input}
              required
              placeholder="Enter Ultravox API key"
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label}>Gamani Key (gKey)</label>
            <input
              type="text"
              value={gKey}
              onChange={(e) => setGKey(e.target.value)}
              className={styles.input}
              required
              placeholder="Enter Gamani API key"
            />
          </div>
        </div>
        {error && <p className={styles.error}>{error}</p>}
        {success && <p className={styles.success}>{success}</p>}
        <button type="submit" className={styles.submitButton}>
          Update Keys
        </button>
      </form>
    </div>
  );
};

export default KeysComponent;